import React from 'react';
import { useSelector } from 'react-redux';
import type { AdminState } from '../../../reducers';
import AgencyInfoForm from '../components/AgencyInfoForm/';
import DataSourceBanner from '../components/DataSourceBanner';
import JurisdictionDetails from '../components/JurisdictionDetails/';

// The psap-management section renders a single page; it is the index route of
// the /admin/psap layout in the consolidated route table (app/Main.tsx).
// JurisdictionDetails is only shown for the capstone application.
const PsapPage = () => {
  const application = useSelector(
    (state: AdminState) => state.sinatra?.user?.currentRole?.application,
  );
  const isCapstone = application === 'capstone';

  return (
    <>
      <DataSourceBanner />
      <AgencyInfoForm />
      {isCapstone && <JurisdictionDetails />}
    </>
  );
};

export default PsapPage;
